import { Box } from "@mui/material";
import { highlightTextSx } from "../theme/styles";

type MazeMultiSelectProps = {
  options: string[];
  value: string;
  onChange: (nextValue: string) => void;
};

export function MazeMultiSelect({
  options,
  value,
  onChange,
}: MazeMultiSelectProps) {
  if (options.length === 0) {
    return null;
  }

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        px: 0.5,
      }}
    >
      {options.map((option, index) => {
        const isSelected = value === option;
        return (
          <Box
            key={`${option}-${index}`}
            component="span"
            sx={{ display: "inline-flex", alignItems: "center" }}
          >
            <Box
              component="button"
              type="button"
              onClick={() => onChange(isSelected ? "" : option)}
              sx={(theme) => highlightTextSx(theme, isSelected)}
            >
              {option}
            </Box>
            {index < options.length - 1 ? (
              <Box component="span" sx={{ px: 0.5, fontWeight: 600 }}>
                /
              </Box>
            ) : null}
          </Box>
        );
      })}
    </Box>
  );
}
